var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("print-preview-app-detail-header", {
        attrs: {
          "show-toggle": false,
          "show-print": false,
          "show-back": !_vm.isNewBrowserTab,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c(
        "div",
        {
          style: `height: calc(100vh - ${_vm.toolbarHeight}px); overflow: hidden;`,
          attrs: { id: "pdf-container", name: "pdf-container" },
        },
        [
          _c(
            "object",
            {
              staticClass: "pdf-document",
              attrs: {
                id: "pdfDoc",
                data: _vm.pdfUrl,
                type: "application/pdf",
              },
            },
            [
              _c("embed", {
                staticClass: "pdf-document",
                attrs: { src: _vm.pdfUrl, type: "application/pdf" },
              }),
            ]
          ),
        ]
      ),
      _vm.isExportModalActive
        ? _c("print-preview-export-modal", {
            attrs: { active: _vm.isExportModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isExportModalActive = $event
              },
              exportReport: _vm.exportReport,
              close: _vm.closeExportModal,
            },
          })
        : _vm._e(),
      _vm.isEmailModalActive
        ? _c(
            "vue-email-modal",
            {
              attrs: {
                active: _vm.isEmailModalActive,
                "icon-name": "mdi-email-open",
                "icon-type": "primary",
                "enable-send": _vm.enableSend && !_vm.isImageAttachActive,
                "enable-attach": _vm.enableAttach,
                "toggle-attach-button": _vm.isImageAttachActive,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isEmailModalActive = $event
                },
                send: _vm.sendEmail,
                discard: _vm.discardEmail,
                attach: _vm.attachMedia,
                "show-attach": _vm.showAttachImage,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.isEmailModalActive
                    ? _c("vue-email", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isImageAttachActive,
                            expression: "!isImageAttachActive",
                          },
                        ],
                        ref: "emailer",
                        attrs: {
                          "report-bytes": _vm.reportBytes,
                          "report-name": `${_vm.emailer.reportName}.${_vm.reportExtension}`,
                          "report-content-type": _vm.reportContentType,
                          "quote-image-attachments": _vm.selectedImages,
                        },
                        on: { "new-email": _vm.newEmailInput, sent: _vm.sent },
                        model: {
                          value: _vm.emailer,
                          callback: function ($$v) {
                            _vm.emailer = $$v
                          },
                          expression: "emailer",
                        },
                      })
                    : _vm._e(),
                  _vm.emailer && _vm.isImageAttachActive
                    ? _c("image-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isImageAttachActive,
                            expression: "isImageAttachActive",
                          },
                        ],
                        attrs: { "quote-id": _vm.emailer.assetId },
                        model: {
                          value: _vm.selectedImages,
                          callback: function ($$v) {
                            _vm.selectedImages = $$v
                          },
                          expression: "selectedImages",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }